<div class="container">
    <app-section-header
        title="{{ building?.name }}"
        subTitle="Buildings"
        [actionsTemplate]="actionsTemplate"
        iconName="goBack"
        [mainAdditionalTemplate]="statusTemplate"
    >
        <ng-template #statusTemplate>
            @if (!isActive) {
                <lib-status-indicator
                    [iconName]="'archived'"
                    [colorType]="'error'"
                    [text]="'Archived'"
                ></lib-status-indicator>
            }
        </ng-template>

        <ng-template #actionsTemplate>
            <div class="actions">
                @if (currentTab === 'Overview') {
                    <button role="menuitem" class="primary-btn" (click)="onEditBuilding()">Edit</button>
                }
                <app-kebab-menu>
                    @if (isActive) {
                        <button role="menuitem" class="resetStyles" (click)="archiveBuilding()">Archive</button>
                    } @else {
                        <button role="menuitem" class="resetStyles" (click)="restoreBuilding()">Restore</button>
                    }
                </app-kebab-menu>
            </div>
        </ng-template>
    </app-section-header>

    <div class="tabGroup">
        <lib-tab-view
            [(currentTab)]="currentTab"
            (currentTabChange)="tabChange($event)"
            alignment="start"
            separation="wide"
        >
            <lib-tab-item tabName="Overview" [bodyTemplate]="overviewTab">
                <ng-template #overviewTab>
                    <div class="tab" #scrollable>
                        <app-buildings-single-overview [building]="building"></app-buildings-single-overview>
                    </div>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Opportunities" [bodyTemplate]="opportunitiesTab" [headerTemplate]="headerTemplate">
                <ng-template #opportunitiesTab>
                    <app-buildings-single-opportunities [buildingId]="buildingId"></app-buildings-single-opportunities>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Contacts" [bodyTemplate]="contactsTab" [headerTemplate]="headerTemplate">
                <ng-template #contactsTab>
                    <app-buildings-single-contacts
                        [building]="building"
                        (buildingChange)="handleBuildingChange()"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-buildings-single-contacts>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Companies" [bodyTemplate]="companiesTab" [headerTemplate]="headerTemplate">
                <ng-template #companiesTab>
                    <app-buildings-single-companies
                        [building]="building"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-buildings-single-companies>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Activity Log" [bodyTemplate]="activityLogTab">
                <ng-template #activityLogTab>
                    <app-activity-log-grid
                        [entityId]="buildingId"
                        [entityTypeId]="entityTypeId"
                    ></app-activity-log-grid>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Notes" [bodyTemplate]="notesTab" [headerTemplate]="headerTemplate">
                <ng-template #notesTab>
                    <app-notes
                        [entityTypeId]="entityTypeId"
                        [entityId]="$safeNavigationMigration(building?.id)"
                        [entityName]="$safeNavigationMigration(building?.name)"
                        [organizationId]="$safeNavigationMigration(building?.organizationId)"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-notes>
                </ng-template>
            </lib-tab-item>

            <ng-template #headerTemplate let-tab="tab">
                <lib-counter-badge
                    [label]="tab.tabName()"
                    [count]="tabsCounters[tab.tabName()] || 0"
                ></lib-counter-badge>
            </ng-template>
        </lib-tab-view>
    </div>
</div>
